import { StandardAction } from 'redux/types';

import { INotification } from './types';

export default class NotificationAction {
  static ACTION_TYPES = {
    FETCH_NOTIFICATION: 'FETCH_NOTIFICATION',
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    READ_NOTIFICATION: 'READ_NOTIFICATION',
    DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
    TOGGLE_NOTIFICATION: 'TOGGLE_NOTIFICATION',
    READ_ALL: 'READ_ALL',
    DELETE_ALL: 'DELETE_ALL',
  };

  static fetchNotification(notifications: INotification[]): StandardAction<INotification[]> {
    return { type: this.ACTION_TYPES.FETCH_NOTIFICATION, payload: notifications };
  }

  static newNotification(notification: INotification): StandardAction<INotification> {
    return { type: this.ACTION_TYPES.NEW_NOTIFICATION, payload: notification };
  }

  static readNotification(notification: INotification): StandardAction<INotification> {
    return { type: this.ACTION_TYPES.READ_NOTIFICATION, payload: notification };
  }

  static deleteNotification(notification: INotification): StandardAction<INotification> {
    return { type: this.ACTION_TYPES.DELETE_NOTIFICATION, payload: notification };
  }

  static toggleNotification(): StandardAction {
    return { type: this.ACTION_TYPES.TOGGLE_NOTIFICATION };
  }

  static readAll(): StandardAction {
    return { type: this.ACTION_TYPES.READ_ALL };
  }

  static deleteAll(): StandardAction {
    return { type: this.ACTION_TYPES.DELETE_ALL };
  }
}
